import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import { failureMessage } from '../Notifications/notificationsSlice';

import {
	getMedia,
	getMediaCompleted,
	getMediaFailed,
	getProcessingMedia,
	getProcessingMediaCompleted,
	getProcessingMediaFailed,
	getStagedMedia,
	getStagedMediaCompleted,
	getStagedMediaFailed,
	getStagedMediaCount,
	getStagedMediaCountCompleted,
	getStagedMediaCountFailed,
	getStagedMediaDetail,
	getStagedMediaDetailCompleted,
	getStagedMediaDetailFailed
} from './mediaSlice';

export const mediaEpic = (action$, state$) =>
	action$.pipe(
		ofType(getMedia.type),
		mergeMap(async (action) => {
			try {
				// const { search, skip, take } = action.payload;

				const media = await axios.get(`${primaryApi()}/api/v1/media`);

				return media.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getMediaCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getMediaFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export const processingMediaEpic = (action$) =>
	action$.pipe(
		ofType(getProcessingMedia.type),
		mergeMap(async (action) => {
			try {
				const processingMedia = await axios.get(
					`${primaryApi()}/api/v1/media/processing`
				);

				return processingMedia.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getProcessingMediaCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(
					getProcessingMediaFailed(error.message),
					failureMessage(error.message)
				),
				source
			);
		})
	);

export const stagedMediaEpic = (action$) =>
	action$.pipe(
		ofType(getStagedMedia.type),
		mergeMap(async (action) => {
			try {
				const stagedMedia = await axios.get(
					`${primaryApi()}/api/v1/media/staged`
				);

				return stagedMedia.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getStagedMediaCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getStagedMediaFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export const stagedMediaCountEpic = (action$) =>
	action$.pipe(
		ofType(getStagedMediaCount.type),
		mergeMap(async (action) => {
			try {
				const stagedMediaCount = await axios.get(
					`${primaryApi()}/api/v1/media/staged/count`
				);

				return stagedMediaCount.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getStagedMediaCountCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(
					getStagedMediaCountFailed(error.message),
					failureMessage(error.message)
				),
				source
			);
		})
	);

export const stagedMediaDetailEpic = (action$) =>
	action$.pipe(
		ofType(getStagedMediaDetail.type),
		mergeMap(async (action) => {
			try {
				const stagedMedia = await axios.get(
					`${primaryApi()}/api/v1/media/staged/${action.payload}`
				);

				return stagedMedia.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getStagedMediaDetailCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(
					getStagedMediaDetailFailed(error.message),
					failureMessage(error.message)
				),
				source
			);
		})
	);

export default [
	mediaEpic,
	processingMediaEpic,
	stagedMediaEpic,
	stagedMediaCountEpic,
	stagedMediaDetailEpic
];
